import React from 'react';
import { SectionZone } from '@/components';
import { bgColorClassname } from '@/utils';
import { GlobalSettingsInterface } from '@/types';

interface Props {
  gridItems: any[];
  reverseOrderOnMobile?: boolean;
  layout: string;
  globalSettings: GlobalSettingsInterface[];
}

const sizes = {
  '1/2': 'w-full md:w-1/2',
  '1/3': 'w-full md:w-5/12 xl:w-[460px]',
  '2/3': 'w-full md:w-7/12 xl:w-[820px]',
  full: 'w-full',
};
const fullSizes = {
  '1/2': 'w-full md:w-1/2',
  '1/3': 'w-full md:w-5/12 xl:w-1/3',
  '2/3': 'w-full md:w-7/12 xl:w-2/3',
  full: 'w-full',
};

const GridBuilder: React.FC<Props> = ({
  gridItems,
  layout: layoutString,
  reverseOrderOnMobile,
  globalSettings,
}) => {
  // layoutString should not be empty, but if it is, default to 2/3, 1/3
  const layout = layoutString ? layoutString.split(',') : ['2/3', '1/3'];

  return (
    <section className='relative'>
      <div
        className={`relative z-10 mx-auto flex max-w-screen-xl flex-col md:flex-row ${reverseOrderOnMobile ? 'flex-col-reverse' : ''}`}
      >
        {gridItems &&
          gridItems.map((gridItem, index) => {
            const backgroundColorClassname = bgColorClassname(gridItem.backgroundColor);
            return (
              <div
                key={index}
                className={`${sizes[layout[index] as keyof typeof sizes]} ${backgroundColorClassname}`}
              >
                <SectionZone
                  key={index}
                  section={gridItem}
                  layoutWidth={layout[index]}
                  globalSettings={globalSettings}
                />
              </div>
            );
          })}
      </div>
      {/* Absolutely positioned divs to create a background color for each grid item */}
      <div className='absolute left-0 top-0 z-0 flex h-full w-full flex-col md:flex-row'>
        {gridItems &&
          gridItems.map((gridItem, index) => {
            const backgroundColorClassname = bgColorClassname(gridItem.backgroundColor);
            return (
              <div
                key={index}
                className={`${fullSizes[layout[index] as keyof typeof fullSizes]} ${backgroundColorClassname}`}
              />
            );
          })}
      </div>
    </section>
  );
};

export default GridBuilder;
